import { SearchCreateOption } from 'components/common/SearchCreateSelect';
import UserAvatar from 'components/common/UserAvatar';
import { Plus } from 'lucide-react';
import React from 'react'


export type AssociationOption = SearchCreateOption & { reference?: string };

const ContactOptionRow = ({
  option,
  onSelect,
}: {
  option: AssociationOption;
  onSelect: () => void;
}) => (
  <button
    type="button"
    onClick={onSelect}
    className="w-full flex items-center gap-3 px-4 py-2.5 hover:bg-primary-light text-left transition-colors"
  >
    <UserAvatar
      name={option.name}
      profileImageURL={option.imageUrl}
      className="w-8 h-8 text-xs"
    />
    <span className="min-w-0 flex-1 truncate text-sm font-medium text-neutral">
      {option.name}
    </span>
    <span className="flex items-center gap-1 shrink-0 text-xs font-medium text-neutral">
      <Plus className="w-3.5 h-3.5" />
      Add
    </span>
  </button>
);

export default ContactOptionRow